import { useEffect } from "react";

import { BaseLayout } from "components/base-layout";
import { FetchingError } from "components/common/fetching-error";
import { Stack } from "components/common/stack";
import { EasyPayCard } from "components/shared/easypay-card";
import { FaqSidebar } from "components/shared/faq-sidebar";
import { MainLayout } from "components/shared/main-layout";
import { PaperlessCard } from "components/shared/paperless-card";
import { usePaymentPlans, usePolicyDetail } from "data/ss-data-hooks";
import { isEasyPayEligible, scrollToTop, trackEvent } from "utils";

import { Balance } from "./balance";
import { History } from "./history";
import { PaymentPlanSidebar } from "./payment-plan-sidebar";
import { UpcomingPayments } from "./upcoming-payments";

export const Billing = () => {
  const { data, error, isLoading } = usePolicyDetail();
  const { data: paymentPlans } = usePaymentPlans();

  const installments = data?.userBilling.installments;
  const billingEmail = data?.userBillingAddress;
  const transactions = data?.userTransactions.transactions;

  useEffect(() => {
    trackEvent("Billing");
    scrollToTop();
  }, []);

  if (error) {
    return (
      <BaseLayout>
        <MainLayout sidebar={<FaqSidebar page="billing" />}>
          <FetchingError page="Billing" />
        </MainLayout>
      </BaseLayout>
    );
  }

  if (isLoading) {
    return <BaseLayout loading />;
  }

  const Main = () => (
    <Stack>
      <Balance />
      <UpcomingPayments installments={installments ?? []} />
      <History
        transactions={transactions ?? []}
        hasSurplusFee={
          data?.userPolicyProperties.carrierGroup?.toLowerCase() === "sure"
        }
      />
    </Stack>
  );

  const Sidebar = () => (
    <Stack>
      <PaymentPlanSidebar
        userBillingEmailAddress={billingEmail}
        policyPaymentPlans={paymentPlans?.policyPaymentPlans}
      />
      {isEasyPayEligible(data?.userBilling, data?.userDetails) && (
        <EasyPayCard />
      )}
      <PaperlessCard pageName="Billing" />
      <FaqSidebar page="billing" />
    </Stack>
  );

  return (
    <BaseLayout
      availableNotifications={[
        "ScheduledPayment",
        "HomeServices",
        "CancellationPayment",
      ]}
    >
      <MainLayout sidebar={<Sidebar />}>
        <Main />
      </MainLayout>
    </BaseLayout>
  );
};
